(function () {
  var countryList = {
    US: 'United States',
    AT: 'Austria',
    BR: 'Brazil',
    CA: 'Canada',
    CH: 'Switzerland',
    CZ: 'Czechia',
    DK: 'Denmark',
    FI: 'Finland',
    GR: 'Greece',
    IE: 'Ireland',
    IL: 'Israel',
    IT: 'Italy',
    MX: 'Mexico',
    NL: 'Netherlands',
    NO: 'Norway',
    NZ: 'New Zealand',
    PE: 'Peru',
    PH: 'Philippines',
    PL: 'Poland',
    PT: 'Portugal',
    SA: 'Saudi Arabia',
    SE: 'Sweden',
    SG: 'Singapore',
    SK: 'Slovakia',
    FR: 'France',
    GB: 'United Kingdom',
    DE: 'Germany',
    AU: 'Australia',
    BE: 'Belgium',
    ES: 'Spain'
  };

  function setCountryFromStorage(countryEl, code) {
    var stored = localStorage.getItem('hpb_country_list');
    if (stored) {
      try {
        var parsed = JSON.parse(stored);
        if (parsed[code]) {
          countryEl.textContent = parsed[code];
          return true;
        }
      } catch (e) {}
    }

    return false;
  }

  function initFooter(footer) {
    if (footer.dataset.footer2026Initialized === 'true') return;
    footer.dataset.footer2026Initialized = 'true';

    footer.querySelectorAll('.f26-menu-head').forEach(function (head) {
      head.addEventListener('click', function () {
        if (window.innerWidth > 768) return;

        var menu = head.closest('.f26-col-menu');
        if (menu) menu.classList.toggle('is-open');
      });
    });

    if (new URLSearchParams(window.location.search).get('customer_posted') === 'true') {
      var successEl = footer.querySelector('.f26-sub-success');
      if (successEl) successEl.style.display = 'block';
    }

    var termsWrap = footer.querySelector('.f26-terms');
    var form = footer.querySelector('form');
    if (form && termsWrap) {
      var checkbox = termsWrap.querySelector('input[type="checkbox"]');
      var submitBtn = form.querySelector('.f26-sub-btn');
      var errorEl = document.createElement('p');

      errorEl.className = 'f26-terms-error';
      errorEl.textContent = footer.dataset.termsError || 'Please agree to the terms and conditions.';
      termsWrap.insertAdjacentElement('afterend', errorEl);

      function showTermsError(e) {
        if (!checkbox || checkbox.checked) return;

        e.preventDefault();
        e.stopImmediatePropagation();
        errorEl.style.display = 'block';
        termsWrap.style.borderRadius = '3px';
      }

      if (submitBtn) {
        submitBtn.addEventListener('click', showTermsError);
      }

      form.addEventListener('submit', showTermsError);

      if (checkbox) {
        checkbox.addEventListener('change', function () {
          if (!checkbox.checked) return;

          errorEl.style.display = 'none';
          termsWrap.style.outline = '';
        });
      }
    }

    var countryEl = footer.querySelector('.f26-country');
    if (!countryEl) return;

    var code = window.Shopify && window.Shopify.country ? window.Shopify.country : null;
    if (!code) return;

    if (countryList[code]) {
      countryEl.textContent = countryList[code];
      return;
    }

    if (setCountryFromStorage(countryEl, code)) return;

    var pollInterval = setInterval(function () {
      var raw = localStorage.getItem('hpb_country_list');
      if (!raw) return;

      clearInterval(pollInterval);
      try {
        var map = JSON.parse(raw);
        countryEl.textContent = map[code] || code;
      } catch (e) {
        countryEl.textContent = code;
      }
    }, 1000);
  }

  document.querySelectorAll('[data-footer-2026]').forEach(initFooter);

  document.addEventListener('shopify:section:load', function (event) {
    var footer = event.target.querySelector('[data-footer-2026]');
    if (footer) initFooter(footer);
  });
})();
